export default class UserMessageError extends Error {
  private readonly userMessage: string;

  public constructor(message: string) {
    super(message); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(this, new.target.prototype); // Restore prototype chain
    this.name = 'UserMessageError';

    this.userMessage = message;
  }

  public getUserMessage(): string {
    return this.userMessage;
  }
}
